import { useMemo } from 'react';
import { Box, TextButton, useDevice } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from "../../../../i18n";
import styles from "./VariableInsertButton.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetVariableInsertButtonTID = parentTestId => getTestIds(parentTestId);
export function VariableInsertButton(_ref) {
  let {
    onClick,
    disabled,
    testId
  } = _ref;
  const {
    VariableInsertButtonTestIds
  } = useMemo(() => GetVariableInsertButtonTID(testId), [testId]);
  const {
    isMobileDevice
  } = useDevice();
  const {
    t
  } = useLocaleKeys('components.templateVariables');
  return /*#__PURE__*/_jsx(Box, {
    className: styles.variableInsertButtonWrapper,
    children: /*#__PURE__*/_jsx(TextButton, {
      prefixIcon: /*#__PURE__*/_jsx(Box, {
        as: "span",
        className: styles.bracesIcon,
        children: '{ }'
      }),
      underline: "none",
      weight: "normal",
      skin: "primary",
      disabled: disabled,
      onClick: onClick,
      testId: VariableInsertButtonTestIds.Root(),
      children: !isMobileDevice && t.insertButton()
    })
  });
}